import { ArrowDownRight, Phone } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/e88f9df8-0827-4de8-b395-30b21dfa42d4/images/58b2d1ea064a5adbea9c852f6f2734c14407a97c76c0aed5c26c6cc99015d799.png";

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      <img
        src={HERO_IMG}
        alt="Warm minimalist living room"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/70" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 min-h-[100svh] flex flex-col justify-end pb-20 pt-32">
        <div className="max-w-3xl">
          <p
            data-testid="hero-overline"
            className="overline text-white/80 mb-6"
            style={{ color: "#F0CFB7" }}
          >
            Singapore · Resale & BTO Renovation
          </p>
          <h1
            data-testid="hero-title"
            className="font-serif-display text-white text-5xl sm:text-6xl lg:text-[5.4rem] leading-[0.95] tracking-tighter hero-text-shadow"
          >
            Building <em className="italic font-light">meaningful</em> spaces
            for the way you live.
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-7 text-white/90 text-base sm:text-lg max-w-xl font-light leading-relaxed hero-text-shadow"
          >
            Honest pricing. Heritage-grade craftsmanship. From hacking and
            tiling to bespoke interior design — Noah+Rayn turns Singapore
            flats into homes that feel unmistakably yours.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-quote"
              onClick={() => scrollTo("#contact")}
              className="btn-primary rounded-full px-8 py-4 text-sm font-semibold tracking-wide inline-flex items-center gap-2"
            >
              Get a Free Quote
              <ArrowDownRight size={18} />
            </button>
            <a
              data-testid="hero-cta-whatsapp"
              href="https://wa.me/6589867250"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline-light rounded-full px-8 py-4 text-sm font-semibold tracking-wide inline-flex items-center gap-2"
            >
              <Phone size={16} />
              WhatsApp +65 8986 7250
            </a>
          </div>
        </div>

        {/* Bottom stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/20 pt-8">
          {[
            { v: "150+", l: "Homes Completed" },
            { v: "12 yrs", l: "Combined Experience" },
            { v: "30%", l: "Below Industry Quotes" },
            { v: "5.0★", l: "Client Trust Rating" },
          ].map((s, i) => (
            <div key={i} data-testid={`hero-stat-${i}`}>
              <div className="font-serif-display text-white text-3xl sm:text-4xl">
                {s.v}
              </div>
              <div className="text-white/70 text-xs uppercase tracking-[0.18em] mt-1">
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
